// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import './ProjectSummaryTable.css';
// import * as XLSX from 'xlsx'; // ✅ for Excel export

// const AchievementTable = ({ filters }) => {
//   const [data, setData] = useState([]);

//   const fetchAchievementData = async () => {
//     try {
//       const queryParams = filters?.pId ? `?PID=${filters.pId}` : "";
//       const res = await axios.get(`https://api-usersreport-insights.haqdarshak.com/api/ar_project_summary${queryParams}`);
//       setData(res.data.filter(item => item.total_target !== 0)); // ✅ optional: remove zero-target rows
//     } catch (err) {
//       console.error("Error fetching data:", err);
//     }
//   };

//   useEffect(() => {
//     fetchAchievementData();
//   }, [filters]);

//   // Format number with commas
//   const formatNumber = (num) => {
//     const parsed = Number(num);
//     return !isNaN(parsed) ? parsed.toLocaleString('en-IN') : 'N/A';
//   };
  

//   const pid = filters?.pId ?? 'N/A';
//   const status = data.length > 0 && data[0].project_status ? data[0].project_status : 'N/A';

//   const exportToExcel = () => {
//     const exportData = data.map(item => ({
//       Deliverables: typeof item.metric === 'string' ? item.metric.replace(/_/g, ' ') : 'N/A',
//       "Total Target": item.total_target ?? 'N/A',
//       "Achieved (till date)": item.total_value ?? 'N/A',
//       "Total Achieved (%)": item.pct_achieved != null ? `${item.pct_achieved}%` : 'N/A',
//       "Achieved (last week)": item.last_week ?? 'N/A',
//       "%Change (week)": item.wow_change_pct != null ? `${item.wow_change_pct}%` : 'N/A',
//     }));
  
//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Project Summary");
//     XLSX.writeFile(workbook, "Project_Summary.xlsx");
//   };
  
//   return (
//     <div className="table-container1">
//       <h3 className="table-title">Project Performance Summary</h3>

//       {/* ⬇️ PID and Status Section */}
//       <div className="project-info">
//         <p><strong>PID:</strong> {pid}</p>
//         <p><strong>Project Status:</strong> {status}</p>
//       </div>
//       <button className="export-btn" onClick={exportToExcel}>Export to Excel</button>

//       <table className="achievement-table1">
//         <thead>
//           <tr>
//             <th rowSpan="2">Deliverables</th>
//             <th rowSpan="2">Total Target</th>
//             <th colSpan="2">Total Achievement</th>
//             <th colSpan="2">Weekly Achievement</th>
//           </tr>
//           <tr>
//             <th>Achieved (till date)</th>
//             <th>Total Achieved (%)</th>
//             <th>Achieved (last week)</th>
//             <th>%Change (week)</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((item, idx) => (
//             <tr key={idx}>
//               <td>{typeof item.metric === 'string' ? item.metric.replace(/_/g, ' ') : 'N/A'}</td>
//               <td>{item.total_target != null ? formatNumber(item.total_target) : 'N/A'}</td>
//               <td>{item.total_value != null ? formatNumber(item.total_value) : 'N/A'}</td>
//               <td>{item.pct_achieved != null ? `${item.pct_achieved} %` : 'N/A'}</td>
//               <td>{item.last_week != null ? formatNumber(item.last_week) : 'N/A'}</td>
//               <td>{item.wow_change_pct != null ? `${item.wow_change_pct}%` : 'N/A'}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default AchievementTable;
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ProjectSummaryTable.css';
import * as XLSX from 'xlsx'; // ✅ for Excel export

const AchievementTable = ({ filters }) => {
  const [data, setData] = useState([]);

  const fetchAchievementData = async () => {
    try {
      const queryParams = filters?.pId ? `?PID=${filters.pId}` : "";
      const res = await axios.get(
        `https://api-usersreport-insights.haqdarshak.com/api/ar_project_summary${queryParams}`
      );
      setData(res.data.filter(item => item.total_target !== 0)); // ✅ optional: remove zero-target rows
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    fetchAchievementData();
  }, [filters]);

  // Format number with commas
  const formatNumber = (num) => {
    const parsed = Number(num);
    return !isNaN(parsed) ? parsed.toLocaleString('en-IN') : 'N/A';
  };

  // ✅ Mapping function for metric renames
  const formatMetricName = (metric) => {
    if (typeof metric !== 'string') return 'N/A';
    const name = metric.replace(/_/g, ' '); // keep underscore cleanup
    switch (name) {
      case "Target No DFL":
        return "DFL BR";
      case "Target No Yojana Card":
        return "Yojana Card BR";
      case "Benefit Received Citizen":
        return "BR Application in Schemes";
      case "Applications Submitted Citizen":
        return "DS Application in Schemes";
      default:
        return name;
    }
  };

  const pid = filters?.pId ?? 'N/A';
  const status =
    data.length > 0 && data[0].project_status ? data[0].project_status : 'N/A';

  const exportToExcel = () => {
    const exportData = data.map(item => ({
      Deliverables: formatMetricName(item.metric),
      "Total Target": item.total_target ?? 'N/A',
      "Achieved (till date)": item.total_value ?? 'N/A',
      "Total Achieved (%)": item.pct_achieved != null ? `${item.pct_achieved}%` : 'N/A',
      "Achieved (last week)": item.last_week ?? 'N/A',
      "%Change (week)": item.wow_change_pct != null ? `${item.wow_change_pct}%` : 'N/A',
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Project Summary");
    XLSX.writeFile(workbook, "Project_Summary.xlsx");
  };

  return (
    <div className="table-container1">
      <h3 className="table-title">Project Performance Summary</h3>

      {/* ⬇️ PID and Status Section */}
      <div className="project-info">
        <p><strong>PID:</strong> {pid}</p>
        <p><strong>Project Status:</strong> {status}</p>
      </div>
      <button className="export-btn" onClick={exportToExcel}>Export to Excel</button>

      <table className="achievement-table1">
        <thead>
          <tr>
            <th rowSpan="2">Deliverables</th>
            <th rowSpan="2">Total Target</th>
            <th colSpan="2">Total Achievement</th>
            <th colSpan="2">Weekly Achievement</th>
          </tr>
          <tr>
            <th>Achieved (till date)</th>
            <th>Total Achieved (%)</th>
            <th>Achieved (last week)</th>
            <th>%Change (week)</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => (
            <tr key={idx}>
              <td>{formatMetricName(item.metric)}</td>
              <td>{item.total_target != null ? formatNumber(item.total_target) : 'N/A'}</td>
              <td>{item.total_value != null ? formatNumber(item.total_value) : 'N/A'}</td>
              <td>{item.pct_achieved != null ? `${item.pct_achieved} %` : 'N/A'}</td>
              <td>{item.last_week != null ? formatNumber(item.last_week) : 'N/A'}</td>
              <td>{item.wow_change_pct != null ? `${item.wow_change_pct}%` : 'N/A'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AchievementTable;
